import { apiConfig } from "./apiConfig";

const profilePostsUrl = apiConfig.oftheday.profile;

export const getProfilePosts = (axios, slug, page) => axios.get(`${profilePostsUrl}${slug}?page=${page}`);
